import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-leo-e1-health",
  "use": "icon-leo-e1-health-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-leo-e1-health\">\r\n<g transform=\"translate(-178.650 -300.529) scale(1.400912)\">\r\n<path d=\"M512 864L208 560c-96-96-96-252 0-348s252-96 348 0l-22 22 22-22c96-96 252-96 348 0s96 252 0 348L512 864zm0-118l240-240c58-58 58-152 0-210s-152-58-210 0L512 326 482 296c-58-58-152-58-210 0s-58 152 0 210L512 746z\" />\r\n  <path d=\"M224 480h128l64-128 96 256 64-128h224v64H624l-48 96-96-256-80 160H224v-64z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/leo-e1-health.svg
// module id = wkhP
// module chunks = 446